import script from "./more.vue?vue&type=script&setup=true&lang=js"
export * from "./more.vue?vue&type=script&setup=true&lang=js"

import "./more.vue?vue&type=style&index=0&id=114bc9e3&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-114bc9e3"]])

export default __exports__